const PLANNED_ROUTE_COLOR = "#2196F3";
const PRIMARY_STROKE = "rgba(39, 174, 96, 1)";

const MapLegend = ({ isLiveTrip = false, isCompletedTrip = false }) => (
  <div className="flex flex-col gap-2 pt-2 border-t border-gray-200">
    <p className="text-gray-400 text-sm">Map legend:</p>
    <div className="flex flex-col gap-2 text-xs text-gray-600">
      <span className="flex items-center gap-2">
        <span className="w-3 h-3 rounded-full bg-green-500 shrink-0" />
        Start
      </span>
      <span className="flex items-center gap-2">
        <span className="w-3 h-3 rounded-full bg-red-500 shrink-0" />
        End
      </span>
      <span className="flex items-center gap-2">
        <span className="w-3 h-3 rounded-full bg-orange-500 shrink-0" />
        Boarding ↑
      </span>
      <span className="flex items-center gap-2">
        <span className="w-3 h-3 rounded-full bg-amber-600 shrink-0" />
        Drop-off ↓
      </span>
      {isLiveTrip && (
        <span className="flex items-center gap-2">
          <span className="w-4 h-0.5 bg-blue-600 shrink-0" />
          Driver
        </span>
      )}
      <span className="flex items-center gap-2">
        <span
          className="inline-block w-6 border-t-2 border-dashed shrink-0"
          style={{ borderColor: PLANNED_ROUTE_COLOR }}
        />
        Planned route
      </span>
      {(isLiveTrip || isCompletedTrip) && (
        <span className="flex items-center gap-2">
          <span
            className="inline-block w-6 border-t-[3px] shrink-0"
            style={{ borderColor: PRIMARY_STROKE }}
          />
          Driver trail
        </span>
      )}
    </div>
  </div>
);

export default MapLegend;
